import I18n from 'I18n';
import { isRecurring } from 'products-ui-components/utils/recurrence';
import getLineItemProperties from 'products-ui-components/utils/properties/getLineItemProperties';
import { getDiscountType, getSelectedDiscountValue, calculateBaseDiscountedLineItemPrice, calculateLineItemDiscount } from 'products-ui-components/utils/calculations/discounts';
import { getDecimalPrecision } from 'products-ui-components/utils/currency';
// ****************************
// * Single Billed Line Items *
// ***************************
export const calculateFixedLineItemPrice = lineItem => {
  if (isRecurring(lineItem)) {
    return 0;
  }
  const {
    price
  } = getLineItemProperties(lineItem);
  return price;
};
export const calculateFixedDiscountedLineItemPrice = lineItem => {
  if (isRecurring(lineItem)) {
    return 0;
  }
  const {
    discount,
    discountPercentage,
    lineItemCurrencyCode,
    price,
    quantity
  } = getLineItemProperties(lineItem);
  const discountType = getDiscountType(discount, discountPercentage);
  const discountValue = getSelectedDiscountValue(discount, discountPercentage, discountType);
  const decimalDigits = getDecimalPrecision(I18n.currencySymbols, lineItemCurrencyCode);
  const fixedDiscountedLineItemPrice = calculateBaseDiscountedLineItemPrice( /** @FIXME emitted-types convert to number, if it's safe */
  quantity, price, discountValue, discountType, decimalDigits);
  return fixedDiscountedLineItemPrice;
};

/**
 * Returns the total value of all discounts for single billed (fixed price) line items.
 * This includes fixed and percentage discounts.
 *
 * @param {List} lineItems - The lineItems for which to calculate total discount
 * @return {number} The total value of all discounts for single billed line items.
 */
export const calculateTotalSingleBilledDiscount = lineItems => {
  return [...lineItems.values()].reduce((subtotal, lineItem) => {
    if (isRecurring(lineItem)) {
      return subtotal;
    }
    const lineItemDiscount = calculateLineItemDiscount(lineItem);
    return subtotal + lineItemDiscount;
  }, 0);
};

/**
 * Returns the total price of all single billed (fixed price) line items.
 * Total calculated price does not include costs (to the HubSpot
 * customer) of these line items.
 *
 * @param {List} lineItems - The lineItems for which to calculate total price
 * @return {number} The total discounted price of all single billed line items.
 */
export const calculateFixedSubtotal = lineItems => {
  return [...lineItems.values()].reduce((subtotal, lineItem) => {
    if (isRecurring(lineItem)) {
      return subtotal;
    }
    return subtotal + calculateFixedDiscountedLineItemPrice(lineItem);
  }, 0);
};